<div class="layout-content" id="boardUsersDialog">
	<form (ngSubmit)="submit()" [formGroup]="boardUserForm">
		<div *ngIf="saving">
			<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
				<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
			</div>
		</div>
		<p-stepper [(activeStep)]="activeIndex" *ngIf="!saving">
			<!-- DISPOSITIVO DI COMANDO -->
			<p-stepperPanel>
				<ng-template pTemplate="header">
					<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(0)"
						[class]="getColorFirstTab()">
						<div class="flex flex-row align-items-center justify-content-center">
							<i class="pi cm-devices text-2xl pr-2"></i>
							<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'COMMAND_DEVICE' | translate
								}}</label>
						</div>
					</button>
				</ng-template>
				<ng-template pTemplate="content">
					<div
						[class]="onExtendedMobile() ? 'grid' : 'flex w-full align-items-center justify-content-center py-3 my-5'">
						<div *ngFor="let codeType of codeTypes let i = index"
							[class]="onExtendedMobile() ? 'col-6 flex justify-content-center px-0' : ''">
							<button pButton pRipple type="button" label="{{ codeType | translate }}" [disabled]="edit"
								(click)="setCodeType(codeType)"
								class="font-normal border-round flex flex-column text-lg w-10rem h-10rem mx-2 py-5 gap-3"
								[ngClass]="codesTypeButtonColor(codeType)">
								<i class="pi text-6xl {{ getCodeTypeIcon(codeType) }}"></i>
							</button>
						</div>
					</div>
					<div class="grid py-3">
						<div class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-end">
								<p-button label="{{ 'NEXT' | translate }}" icon="pi cm-arrow-right" iconPos="right"
									severity="primary" (onClick)="goToIndexCheckandActive('next')" />
							</div>
						</div>
					</div>
				</ng-template>
			</p-stepperPanel>

			<!-- TIPO DI CODICE -->
			<p-stepperPanel>
				<ng-template pTemplate="header">
					<button *ngIf="secondStepAble()" pButton pRipple type="button" class="bg-transparent h-3rem"
						(click)="changeActiveTabClick(1)" [class]="getColorSecondTab()">
						<div class="flex flex-row align-items-center justify-content-center">
							<!-- <i class="pi {{getCodeTypeIconStep()}} text-2xl pr-2"></i> -->
							<i class="pi cm-radio-controls text-2xl pr-2"></i>
							<!-- <label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ getCodeType() }}</label> -->
							<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'CODE_TYPE' | translate }}</label>
						</div>
					</button>
				</ng-template>

				<ng-template pTemplate="content">
					<div *ngIf="(codeType === 'BOARD_USER')"
						[class]="onExtendedMobile() ? 'grid' : 'flex w-full align-items-center justify-content-center py-3 my-5'">
						<div *ngFor="let modelType of modelTypes let i = index"
							[class]="onExtendedMobile() ? 'col-6 flex justify-content-center px-0' : ''">
							<button pButton pRipple type="button" label="{{ modelType | translate }}" [disabled]="edit"
								(click)="setBURadioModelType(modelType)"
								class="font-normal border-round flex flex-column text-lg w-10rem h-10rem mx-2 py-5 gap-3"
								[ngClass]="modelTypeButtonColor(modelType)">
								<i class="pi text-6xl {{ getModelTypeIcon(modelType) }}"></i>
							</button>
						</div>
					</div>

					<div class="grid py-3">
						<div class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between">
								<p-button label="{{ 'BACK' | translate }}" icon="pi cm-arrow-left" iconPos="left"
									severity="secondary" (onClick)="changeActiveTabClick(0)" />
								<p-button label="{{ 'NEXT' | translate }}" icon="pi cm-arrow-right" iconPos="right"
									severity="primary" (onClick)="changeActiveTabClick(2)" />
							</div>
						</div>
					</div>
				</ng-template>
			</p-stepperPanel>

			<!-- DETTAGLI -->
			<p-stepperPanel>
				<ng-template pTemplate="header">
					<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(2)"
						[class]="getColorThirdTab()">
						<div class="flex flex-row align-items-center justify-content-center">
							<i class="pi cm-info text-2xl pr-2"></i>
							<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'DETAILS' | translate }}</label>
						</div>
					</button>
				</ng-template>

				<ng-template pTemplate="content">
					<div class="grid">
						<div class="col-12 text-lg font-medium text-center">
							<div *ngIf="codeType === 'KEYPAD' || codeType === 'TRANSPONDER'" class="pi {{ getCodeTypeIcon(codeType) }} pr-1"></div>
							<div *ngIf="codeType === 'BOARD_USER'" class="pi {{ getModelTypeIcon(modelType) }} pr-1"></div>
							{{ this.f.type.value.Name }}
						</div>
						<!-- isCodeGroup if there is a Group -->
						<div class="col-12" *ngIf="isCodeGroup" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.groupName, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.groupName, 'label')">{{ 'NAME' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.groupName, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
										id="boarduser-input-groupName" formControlName="groupName"
										autocomplete="boardUser-groupName" placeholder="{{ 'NAME' | translate }}"
										maxlength="40" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.groupName)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<!-- there is no Group -->
						<div class="col-12" *ngIf="!isCodeGroup" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.name, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.name, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="boarduser-input-name"
										formControlName="name" autocomplete="boardUser-name"
										placeholder="{{ 'NAME' | translate }}" maxlength="40" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
						</div>
						<!-- FUNCTION called by Radio, Keypad, Transponder -->
						<div class="col-12" *ngIf="!isCodeGroup && isAClassGroupable" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.mode, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.mode, 'label')">{{ 'FUNCTION' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.mode, 'borderInput')">
									<p-dropdown [options]="buItems" *ngIf="itemsType==='combo'" formControlName="mode"
										[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }} pl-5"
										inputStyleClass="text-center" placeholder="{{ 'FUNCTION' | translate }}" appendTo="body"
										optionValue="Value">
										<ng-template let-item pTemplate="selectedItem">
											<div class="item" class="flex align-items-center justify-content-center">
												<div class="flex justify-content-center">{{ getDescriptionItem(item) }}</div>
											</div>
										</ng-template>
										<ng-template let-item pTemplate="item">
											<div class="item flex align-items-center justify-content-center">
												<div>{{ getDescriptionItem(item) }}</div>
											</div>
										</ng-template>
									</p-dropdown>
									<p-multiSelect formControlName="modeBitmask" *ngIf="itemsType==='bitmask'"
										[options]="filter(buItems)" optionValue="Value" appendTo="body"
										optionLabel="DescriptionItem" [ngClass]="dynamicInputTextWidth()"
										[styleClass]="dynamicInputTextWidth()" optionDisabled="inactive"
										(onChange)="disableListCommand(buItems)" [showToggleAll]="false"
										selectedItemsLabel="{{'SELECTED_ITEM' | translate }}{0}">
										<ng-template let-items pTemplate="selectedItems">
											<span *ngFor="let item of items;">
												<span class="font-medium text-0">{{ item.DescriptionItem }}, </span>
											</span>
										</ng-template>
										<ng-template let-item pTemplate="item">
											<div class="item">
												<div>{{ item.DescriptionItem }}</div>
											</div>
										</ng-template>
									</p-multiSelect>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.mode)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
						</div>
						<!-- MODEL EDIT (BOARD_USERS && KEYPAD) -->
						<div class="col-12"
							*ngIf="edit && (isCodeGroup || (!isCodeTypeGroupable && isRc)) && f.type.value !== undefined"
							[ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.typeDescription, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.typeDescription, 'label')">{{ 'MODEL' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.typeDescription, 'borderInput')">
									<p-dropdown [options]="f.type.value.Items" formControlName="typeDescription" appendTo="body"
										[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }} pl-5"
										inputStyleClass="text-center" placeholder="{{ 'MODEL' | translate }}">
									</p-dropdown>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.typeDescription)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<!-- MODEL ADD (also EDIT TRANSPONDER)-->
						<div class="col-12" *ngIf="(!edit || isBadge) && f.type.value !== undefined && buTypeDescriptionVisible"
							[ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.typeDescription, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.typeDescription, 'label')">{{ 'MODEL' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.typeDescription, 'borderInput')">
									<p-dropdown [options]="f.type.value.Items" formControlName="typeDescription" appendTo="body"
										[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }} pl-5"
										inputStyleClass="text-center" placeholder="{{ 'MODEL' | translate }}"
										> <!-- [disabled]="!isBadge" : see get isBadge() -->
									</p-dropdown>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.typeDescription)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<!--CODE-->
						<div class="col-12 pb-4" [ngClass]="customPaddingX()" *ngIf="!isCodeGroup">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.code, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.code, 'label')">{{ 'CODE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.code, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" [min]="codeMin"
										[max]="codeMax" [maxlength]="codeLength" id="boarduser-input-code" formControlName="code"
										autocomplete="boardUser-code" [placeholder]="codePlaceholder" maxlength="25" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.code)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyContentStyle()">{{ 'INVALID_CODE' | translate }}</small>
						</div>
						<!--BUTTON-NUMBER-->
						<div class="col-12 pb-4" [ngClass]="customPaddingX()"
							*ngIf="!isCodeGroup && !edit && isCodeTypeGroupable && buttonNumber >= 0">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.buttonNumber, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.buttonNumber, 'label')">{{ 'BUTTON_NUMBER' | translate }}
								</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.buttonNumber, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
										id="boarduser-input-button-number" formControlName="buttonNumber" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.buttonNumber)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'INVALID_CODE'
								| translate }}</small>
						</div>
						<!--POSITION-->
						<div class="col-12 pb-4" [ngClass]="customPaddingX()" *ngIf="!isCodeGroup && edit">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.position, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.position, 'label')">{{ 'POSITION' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.position, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
										id="boarduser-input-position" formControlName="position" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.position)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'INVALID_CODE'
								| translate }}</small>
						</div>
						<!--CONTROL ACCESS---------------------------- -->
						<!-- Group -->
						<div class="col-12 pb-4" [ngClass]="customPaddingX()"
							*ngIf="isRbe24230Model() && !isCodeGroup && isFunctionControlAccessSuppor()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.Group, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.Group, 'label')">{{ 'GROUPS' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.Group, 'borderInput')">
									<p-dropdown [options]="listGroup" optionLabel="Name" [ngClass]="dynamicInputTextWidth()"
										appendTo="body" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-6"
										panelStyleClass="text-center" formControlName="Group" [showClear]="true"
										placeholder="{{ 'GROUPS' | translate }}" optionValue="Id" dataKey="Id">
									</p-dropdown>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.Group)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
						</div>
						<div class="col-12" [ngClass]="customPaddingX()"
							*ngIf="isRbe24230Model() && !isCodeGroup && isFunctionControlAccessSuppor()">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
								[ngClass]="simpleInputTextLayout('borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="simpleInputTextLayout('label')">{{ 'TEMPORARY_ACCESS' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="simpleInputTextLayout('borderInput')">
									<!-- <p-toggleButton [onLabel]="('TEMPORARY_ACCESS_ON' | translate )"
										formControlName="EnableTemporaryAccess" [offLabel]="('TEMPORARY_ACCESS_OFF' | translate )"
										styleClass="p-togglebutton-successdanger" /> -->
									<p-inputSwitch inputId="boarduser-temp-access" formControlName="EnableTemporaryAccess"></p-inputSwitch>
								</div>
							</div>
						</div>
						<div class="col-12" [ngClass]="customPaddingX()"
							*ngIf="isRbe24230Model() && !isCodeGroup && isFunctionControlAccessSuppor()">
							<p-panel header="{{ 'TEMPORARY_ACCESS'  | translate }}" *ngIf="this.f.EnableTemporaryAccess.value"
								styleClass="p-panel-whitebg mb-3">
								<div class="grid">
									<div [ngClass]="col12ResponsiveNoPaddingCol6()" class="px-3">
										<div class="flex justify-content-between flex-wrap"
											[ngClass]="newShowErrors(this.f.StartDate, 'borderRow')">
											<div class="flex align-items-center justify-content-center"
												[ngClass]="newShowErrors(this.f.StartDate, 'label')">{{ 'START_DATE' | translate }}
											</div>
											<div class="flex align-items-center justify-content-center"
												[ngClass]="newShowErrors(this.f.StartDate, 'borderInput')">
												<p-calendar [showIcon]="true" inputId="icon" formControlName="StartDate"
													appendTo="body" placeholder="dd/mm/yyyy" dateFormat="dd/mm/yy"
													[ngClass]="dynamicInputTextDesktopTabletWidth()"
													[styleClass]="dynamicInputTextDesktopTabletWidth()"
													inputStyleClass="pl-5 border-noround-right"
													[panelStyleClass]="dynamicDatepicker()">
												</p-calendar>
											</div>
										</div>
										<small *ngIf="showErrorRequiredMessage(this.f.StartDate)"
											class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{
											'REQUIRED' | translate }}</small>
									</div>
									<div [ngClass]="col12ResponsiveNoPaddingCol6()" class="px-3">
										<div class="flex justify-content-between flex-wrap"
											[ngClass]="newShowErrors(this.f.EndDate, 'borderRow')">
											<div class="flex align-items-center justify-content-center"
												[ngClass]="newShowErrors(this.f.EndDate, 'label')">{{ 'END_DATE' | translate }}
											</div>
											<div class="flex align-items-center justify-content-center"
												[ngClass]="newShowErrors(this.f.EndDate, 'borderInput')">
												<p-calendar [showIcon]="true" inputId="icon" formControlName="EndDate"
													appendTo="body" placeholder="dd/mm/yyyy" dateFormat="dd/mm/yy"
													[ngClass]="dynamicInputTextDesktopTabletWidth()"
													[styleClass]="dynamicInputTextDesktopTabletWidth()"
													inputStyleClass="pl-5 border-noround-right"
													[panelStyleClass]="dynamicDatepicker()">
												</p-calendar>
											</div>
										</div>
										<small *ngIf="showErrorRequiredMessage(this.f.EndDate)"
											class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{
											'REQUIRED' | translate }}. {{ 'TAG_DATE_WARNING_INVALID' | translate }}</small>
									</div>
								</div>
							</p-panel>
						</div>
						<!--CONTROL ACCESS -->
						<div class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-start">
								<p-button label="{{ 'BACK' | translate }}" icon="pi cm-arrow-left" severity="secondary"
									(onClick)="goToIndexCheckandActive('back')" />
							</div>
						</div>
					</div>

				</ng-template>
			</p-stepperPanel>

			<ng-template pTemplate="end">
				<div class="grid mt-2 mb-1 mx-1 flex justify-content-center align-items-center">
					<button *ngIf="enableConfirmButtons()" type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
						class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
					</button>
					<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
						class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
					</button>
				</div>
			</ng-template>
		</p-stepper>
	</form>
</div>